import axios from 'axios'
import baseUrl from '../../helpers/baseurl'

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    'Accept':'*/*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
    'xsrfCookieName': "XSRF-TOKEN",
    'xsrfHeaderName': "X-XSRF-TOKEN",
  },
})

apiClient.interceptors.request.use((request) => {
  const accessToken = localStorage.getItem('tokenAccess')
  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${JSON.parse(accessToken)}`
  }
  return request
})

export default apiClient